// 1. ROLE DEFINITIONS
export const ROLES = {
    DEV: 'Dev',                     // Global Master (God Mode)
    SUPPORT: 'Support',             // Global Observer
    SERVER_SUPER_ADMIN: 'Super Admin', // Local Server Manager
    ADMIN: 'Admin',                 // Standard Admin
    EMPLOYEE: 'Employee'
};

// 2. CONFIGURATION (The Control Panel)
// 2. CONFIGURATION (The Control Panel)
export const PERMISSIONS_CONFIG = {
    // Who can PERMANENTLY DELETE users/servers?
    CAN_DELETE_DATA: [ ROLES.DEV ], 

    // Who can REMOVE users from a specific server (Local Unlink)?
    CAN_LOCAL_DELETE: [ ROLES.DEV, ROLES.SUPPORT ],

    // Who can view the "Requested OTPs" page?
    CAN_VIEW_SENSITIVE_OTPS: [ ROLES.DEV ],

    // Who can view and manage Onboarding360 Purgatory & Inactivity?
    CAN_VIEW_ONBOARDING_PURGATORY: [ ROLES.DEV ],

    // Who can Create NEW Global Admins and Send Global Broadcasts?
    CAN_MANAGE_GLOBAL_ADMINS: [ ROLES.DEV ],
    CAN_SEND_GLOBAL_BROADCAST: [ ROLES.DEV ],

    // Who can view All Servers & Global User List?
    CAN_VIEW_GLOBAL_DASHBOARD: [ ROLES.DEV, ROLES.SUPPORT ],

    // Who can Edit data? (Local Admins omitted - strictly Read-Only for now)
    CAN_EDIT_DATA: [ ROLES.DEV, ROLES.SUPPORT ], 
};

// 3. Helper Logic
export const hasPermission = (userRole, action) => {
    if (!userRole) return false;
    const allowedRoles = PERMISSIONS_CONFIG[action] || [];
    return allowedRoles.includes(userRole);
};